import jQuery from 'jquery';
import config from '_config';
import sizeof from 'object-sizeof';

if (typeof config.language.LanguageFile.ajax['request-timeout'] == 'undefined') config.language.LanguageFile.ajax['request-timeout'] = "Your request timed out";
if (typeof config.language.LanguageFile.ajax['unknown-error'] == 'undefined') config.language.LanguageFile.ajax['unknown-error'] = "Unknown error occured";

class TH_AjaxCalls {
    constructor(settings) {
        if (settings == 'undefined') settings = {};
        this.Translate = null;
        this.settings = {
            ajaxTimeout: 10000,
            defaultSendMethod: 'GET',
            debug: true,
            cache: {
                maxSize: 2097152, // 2 MB,
                defaultCacheTime: 3000000 // 5 minutes
            }
        };

        jQuery.extend(true, this.settings, settings);

        this.cache = {};
        this.cacheOrder = new Array();
        this.cacheSize = 0;
        this.selfLog = new Array();
        this.calls = {};
    }

    /** Set the translate instance for ajax calls to use
     * 
     * 
     */
    setTranslate(Translate) {
        this.Translate = Translate;
    }

    /** Logging function for ajax calls
     * 
     */
    log(fromLine) {
        let logData = new Array(),
            time = new Date();
    
        time = time.toTimeString().split(' ')[0];
        logData.push('Line ' + fromLine);
        logData.push(time);
        for (i = 1; i < arguments.length; i++) logData.push(arguments[i]);
        //if (this.settings.debug) console.log.apply(console, logData);
        this.selfLog.push(logData);
    }

    /** Show the inner log of this instance
     * 
     */
    showLog() {
        for (let i = 0; i < this.selfLog.length; i++) console.log.apply(console, this.selfLog[i]);
        return 'Log of AjaxCalls: ';
    }

    /** Perform an ajax request
     * 
     */
    async ajaxRequest(ajaxSettings, fromCache, callbackfunction, additionalParams) {
        let ajaxCallObject = this;


        return new Promise(function(resolve, reject) {
            let cacheId = ajaxSettings.url + JSON.stringify(ajaxSettings.data),
                ajaxCallId = utils.default.guid(),
                ajaxTime = new Date().getTime(),
                requestOptions = {
                    timeout: ajaxCallObject.settings.ajaxTimeout,
                    type: ajaxCallObject.settings.defaultSendMethod,
                    async: true,
                    dataType: 'jsonp'
                }

            jQuery.extend(true, requestOptions, ajaxSettings);

            if (ajaxCallObject.cache[cacheId] !== undefined && fromCache === true && ajaxCallObject.cache[cacheId]['cacheuntil'] > Date.now()) {
                resolve(ajaxCallObject.getCacheData(callbackFunction, cacheId, requestOptions.data, additionalParams));
            }

            requestOptions.data['ajaxCallid'] = ajaxCallId;
            requestOptions.data['javascript'] = true;

            ajaxCallObject.calls[ajaxCallId] = 'waiting';
            
            console.log(requestOptions.url, window.location.hostname);
            if ('http://' + window.location.hostname != requestOptions.url && window.location.hostname != requestOptions.url) {
                requestOptions.xhrFields = {
                    withCredentials: true
                };
            }

        
            console.log('Sending ajax request', requestOptions);
            jQuery.ajax(requestOptions).done(function(data) {
                let totalTime = new Date().getTime() - ajaxTime;

                console.log("Runtime of ajax: ", totalTime);
                console.log('Response from ' + requestOptions.data['page'], data);

                ajaxCallObject.addToCache(cacheId, data);
                if (typeof data.ajaxCallId != 'undefined') {
                    if (ajaxCallObject.calls[data.ajaxCallId] == 'aborted') {
                        ajaxCallObject.log(new Error().lineNumber, 'Ajax response arrived, not needed anymore... trashing...', data);
                        resolve(false);
                    } else ajaxCallObject.calls[data.ajaxCallId] = 'arrived';
                }

                resolve(data);
            }).fail(function(jqXHR, textStatus) {
                let errorParams = {
                        result: false,
                        errors: {
                            plain_message: ''
                        }
                    };

                if (textStatus == 'timeout') {
                    errorParams.errors['plain_message'] = ajaxCallObject.Translate.text("Your request timed out. There may be an error in your internet connection, or an error on our server. Please try again, and if the problem persists, contact %0 support, and don't forget to provide them the following error code: %1", config.brandName, '<b>ERRAJO100</b>');
                    resolve(errorParams);
                } else {
                    errorParams.errors['plain_message'] = ajaxCallObject.Translate.text("An unknown error has occured and your request failed. Please try again, and if the problem persists, contact %0 support, and don't forget to provide them the following error code: %1", config.brandName, '<b>ERRAJO101</b>');
                    resolve(errorParams);
                }
            });
        });
    }

    /** Perform a basic ajax call
     * 
     * 
     */
    async ajaxCall(url, sendData, fromCache) {

        if (sendData === undefined) sendData = {};
        if (fromCache === undefined) fromCache = false;

        return await this.ajaxRequest({
            type: this.settings.defaultSendMethod,
            url: url,
            data: sendData
        }, fromCache);
    }

    /** Perform an ajax get call
     * 
     */
    async ajaxGet(url, sendData, fromCache) {
        if (sendData === undefined) sendData = {};
        if (fromCache === undefined) fromCache = false;
        return this.ajaxRequest({
            type: 'GET',
            url: url,
            data: sendData
        }, fromCache);
    }


    /** Perform an ajax post call - DEPRECATED, use ajaxPost async
     * 
     */
    async ajaxPost(url, sendData, fromCache) {
        if (sendData === undefined) sendData = {};
        if (fromCache === undefined) fromCache = false;
        return await this.ajaxRequest({
            type: 'POST',
            url: url,
            data: sendData
        }, fromCache);
    }

    /** Run an ajax request from the cache
     * 
     */
    getCacheData(cacheId) {
        let cacheData = this.cache[cacheId]['data'];

        return cacheData;
    }

    /** Clear the inner cache of the ajax instance
     * 
     */
    clearCache() {
        this.cache = {};
    }

    /** Add some data to the cache
     * 
     * @param string cacheId    (the cacheId to use)
     * @param string data       (the data to add to the cache)
     * 
     */
    addToCache(cacheId, data) {
        while (!this.dataFitsInCache(data)) this.freeUpCache();

        if (this.cache[cacheId] === undefined) this.cache[cacheId] = {};
        else {
            delete this.cache[cacheId];
            this.cache[cacheId] = {};
            this.cacheOrder.splice(this.cacheOrder.indexOf(cacheId), 1);
        }

        this.cache[cacheId]['data'] = data;
        if (typeof data.cacheFor !== 'undefined') this.cache[cacheId]['cacheuntil'] = Date.now() + data.cacheFor * 1000;
        else this.cache[cacheId]['cacheuntil'] = Date.now() + this.settings.cache.defaultCacheTime;

        this.cacheOrder.push(cacheId);
        this.cacheSize = sizeof(this.cache);
    }

    /** Check if the data fits in the cache
     * 
     * @param mixed data (the data that we want to put in the cache)
     * 
     */
    dataFitsInCache(data) {
        let cacheSizeNow = sizeof(this.cache),
            dataSize = sizeof(data),
            totalSize = dataSize + cacheSizeNow + parseInt(Date.now().length);

        if (totalSize > this.settings.cache.maxSize) return false;
        else return true;
    }

    /** Free up some cache data
     * 
     */
    freeUpCache() {
        delete this.cache[this.cacheOrder[0]];
        this.cacheOrder.splice(0, 1);
    }

    /** Stop all pending ajax calls
     * 
     */
    stopCalls() {
        if (arguments.length == 0) {
            for (let callid in this.calls) {
                if (this.calls[callid] == 'waiting') this.calls[callid] = 'aborted';
            }
        } else {
            for (let i = 0; i < arguments.length; i++) {
                if (this.calls[arguments[i]] !== undefined && this.calls[arguments[i]] == 'waiting') this.calls[arguments[i]] = 'aborted';
            }
        }
    }
}

export default TH_AjaxCalls;